import React from "react"
import { MainCP } from "../../Components/aprobacion-mensual/MainCP"


const ViewAprobacionMensual: React.FC = () => <MainCP/>
 

export default ViewAprobacionMensual;


      


